// extracted by mini-css-extract-plugin
export default {"root":"TableTitle_root__4BbXY","active":"TableTitle_active__LNhWZ"};